import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class HighlightsCounter {
  constructor() {
    this.section = document.querySelector(".highlights__section");
    this.counters = this.section?.querySelectorAll(".count-wrapper span");

    if (this.section && this.counters?.length) {
      this.init();
    }
  }

  init() {
    ScrollTrigger.create({
      trigger: this.section,
      start: "top 85%",
      once: true,
      onEnter: () => this.animateCounters(),
    });
  }

  animateCounters() {
    this.counters.forEach((counter) => {
      const targetValue = parseInt(counter.textContent, 10);
      const duration = Math.min(1.5 + targetValue / 100, 2);

      gsap.fromTo(
        counter,
        { innerText: 0 },
        {
          innerText: targetValue,
          duration: duration,
          ease: "power2.out",
          snap: { innerText: 1 },
          onUpdate() {
            counter.textContent = Math.floor(counter.innerText);
          },
          onComplete() {
            counter.textContent = targetValue.toLocaleString();
          },
        }
      );
    });
  }
}
